import { render, staticRenderFns } from "./BlogHowSmallBusinessesCanCompete.vue?vue&type=template&id=0941e552"
import script from "./BlogHowSmallBusinessesCanCompete.vue?vue&type=script&lang=js"
export * from "./BlogHowSmallBusinessesCanCompete.vue?vue&type=script&lang=js"
import style0 from "./BlogHowSmallBusinessesCanCompete.vue?vue&type=style&index=0&id=0941e552&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports